<template>
    <div >
        <b>{{item}}</b>
    </div>
</template>

<script>
    export default {
        props: {
            item: { required: true },
            searchText: { required: true }
        }
    }
</script>

<style>
    .v-autocomplete-list{
        background: white;
        position: absolute;
        z-index:1;
    }

    .v-autocomplete-list .v-autocomplete-list-item{
        padding: 6px 6px;
        border: 1px solid #eeeeee;
        border-bottom: 0px;
    }

    .v-autocomplete-list .v-autocomplete-item-active{
        background: #1e9dee;
        color:white;
    }



</style>